import { observer } from "mobx-react-lite";
import React from "react";
import { ToggleGroup, XStack } from "tamagui";
import { ToggleGroupItem } from "../../../core/components/ToggleGroupItem";
import { Body } from "../../../ui/Body";
import { Box } from "../../../ui/Box";
import { Label } from "../../../ui/Label";
import type { BusinessSettings } from "../BusinessPlanModel";

const ToggleSettingArea = observer(
  ({
    label,
    isTrue,
    onChange,
  }: {
    label: string;
    isTrue: boolean;
    onChange: (v: boolean) => void;
  }) => {
    return (
      <XStack
        gap="$medium"
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Label>{label}</Label>
        <ToggleGroup
          type="single"
          value={isTrue ? "true" : "false"}
          onValueChange={(value: string) => {
            onChange(value === "true");
          }}
          disablePassBorderRadius
          padding={1}
        >
          <ToggleGroupItem active={isTrue} value={"true"}>
            <Body>Yes</Body>
          </ToggleGroupItem>
          <ToggleGroupItem active={!isTrue} value={"false"}>
            <Body>No</Body>
          </ToggleGroupItem>
        </ToggleGroup>
      </XStack>
    );
  },
);

export const BusinessPlanSettingsBox = observer(
  ({
    settings,
    onChange,
  }: {
    settings: BusinessSettings;
    onChange: (updatedSettings: BusinessSettings) => void;
  }) => {
    return (
      <Box>
        <ToggleSettingArea
          label={"Use introduction text"}
          isTrue={settings.useIntroductionText}
          onChange={(status) => {
            onChange({ ...settings, useIntroductionText: status });
          }}
        />

        <ToggleSettingArea
          label={"Use Private Planira"}
          isTrue={settings.usePlanira}
          onChange={(status) => {
            onChange({ ...settings, usePlanira: status });
          }}
        />

        <ToggleSettingArea
          label={"Use Swedish"}
          isTrue={settings.useLocale === "sv"}
          onChange={(status) => {
            onChange({ ...settings, useLocale: status ? "sv" : "en" });
          }}
        />
      </Box>
    );
  },
);
